import { ComponentType, useEffect, useState } from 'react';

export const Timer: ComponentType<{ timeLeft: number }> = ({ timeLeft }) => {
  const minutes = Math.floor((timeLeft - 1) / 60);
  const seconds = (timeLeft - 1) % 60;
  const [[mins, secs], setTime] = useState([minutes, seconds]);

  const tick = () => {
    if (secs === 0) {
      setTime([mins - 1, 59]);
    } else {
      setTime([mins, secs - 1]);
    }
  };

  useEffect(() => {
    let timerId: any;
    if (!(mins === 0 && secs === 0)) timerId = setInterval(() => tick(), 1000);

    return () => clearInterval(timerId);
  });

  return (
    <>
      {mins.toString().padStart(2, '0')}:{secs.toString().padStart(2, '0')}
    </>
  );
};
